<template>
  <v-container>
    <v-dialog v-model="addScheduleTime" max-width="900px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col cols="3">
            <v-btn style="width: 100%;" right color="primary" dark class="mb-2" v-on="on" @click="addedItem()">
              {{$t('add_shift_code')}}</v-btn>
          </v-col>
          <v-col md="6 pt-0">
            <v-text-field :label="$t('find_shift_code')" prepend-inner-icon="mdi-magnify" single-line v-model="search"
              :rules="[validator.alfaNumberNotRequired]"></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-form v-model="valid" ref="addForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('add_shift_code')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('shift_code')" v-model="addItem.schedule_code"
                    :rules="[...rulesMaxChar, validator.alfaForInput]">
                    <template slot="append">
                    <span v-if="addItem.schedule_code">{{ addItem.schedule_code.length }}/8</span>
                    <span v-else>0/8</span>
                  </template></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field :label="$t('title')" v-model="addItem.description"
                    :rules="[...rulesMaxChar50, validator.alfaForInput]">  <template slot="append">
                      <span v-if="addItem.description">{{ addItem.description.length }}/50</span>
                      <span v-else>0/50</span>
                  </template></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" style="position: relative;"
                  :class="lang === 'id' ? 'set-radio2' : 'set-radio1'">
                  <v-switch class="label-12" inset :label="checkbox ? `Active` : `Inactive`" v-model="checkbox"
                    @change="changeRules">
                  </v-switch>
                </v-col>
                <v-col cols="3" sm="6" md="3">
                  <v-text-field :label="$t('work_in')" v-model="addItem.work_in" type="time" :rules="[...rulesHoliday, ...rulesMidnight]"
                    :disabled="disableInput"></v-text-field>
                </v-col>
                <v-col cols="3" sm="6" md="3">
                  <v-text-field :label="$t('work_out')" v-model="addItem.work_out" type="time" :rules="[...rulesHoliday, ...rulesMidnight]"
                    :disabled="disableInput"></v-text-field>
                </v-col>
                <v-col cols="3" sm="6" md="3">
                  <v-select :label="$t('timezone')" v-model="addItem.timezone" :rules="rulesHoliday" :items="timezone"
                    item-text="name" item-value="id" :disabled="disableInput"></v-select>
                </v-col>
                <v-col cols="3" sm="6" md="3">
                  <v-text-field :label="$t('tolerance')" v-model="addItem.tolerance"  :rules="rules4"
                    :disabled="disableInput">
                    <template slot="append">
                     <div  style="font-size: 12px; line-height: 16px; color: #686868;">{{ $t('minutes') }}</div>
                     </template>
                  </v-text-field>
                </v-col>
                <!-- <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('break_in')"
                    v-model="addItem.break_in"
                    type="time"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('break_out')"
                    v-model="addItem.break_out"
                    type="time"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" style="border: solid 1px #3277D5;" text @click="close" class="mr-2">
                {{$t('cancel')}}</v-btn>
              <v-btn :loading="loading" color="primary" @click="addListTime(addItem)" :disabled="!valid">{{$t('save')}}
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editScheduleTime" max-width="900px">
      <v-card class="pt-3">
        <v-card-title>
          <span class="headline ml-2">{{$t('edit_master_shift_code')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('shift_code')" v-model="editItem.schedule_code"
                  :rules="[...rulesMaxChar, validator.alfaForInput]">
                  <template slot="append">
                    {{ editItem.schedule_code.length }}/8
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field :label="$t('title')" v-model="editItem.description"
                  :rules="[...rulesMaxChar50, validator.alfaForInput]">
                  <template slot="append">
                    {{ editItem.description.length }}/50
                  </template></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" style="position: relative;"
                :class="lang === 'id' ? 'set-radio2' : 'set-radio1'">
                <v-switch class="label-12" :label="checkbox ? `Active` : `Inactive`" v-model="checkbox"
                  @change="changeRules">
                </v-switch>
              </v-col>
              <v-col cols="3" sm="6" md="3">
                <v-text-field :label="$t('work_in')" v-model="editItem.work_in" type="time" :rules="[...rulesHoliday, ...rulesMidnight]"
                  :disabled="disableInput"></v-text-field>
              </v-col>
              <v-col cols="3" sm="6" md="3">
                <v-text-field :label="$t('work_out')" v-model="editItem.work_out" type="time" :rules="[...rulesHoliday, ...rulesMidnight]"
                  :disabled="disableInput"></v-text-field>
              </v-col>
              <v-col cols="3" sm="6" md="3">
                <v-select :label="$t('timezone')" v-model="editItem.timezone" :rules="rulesHoliday" :items="timezone"
                  item-text="name" item-value="id" :disabled="disableInput"></v-select>
              </v-col>
              <v-col cols="3" sm="6" md="3">
                <v-text-field :label="$t('tolerance_in_min')" v-model="editItem.tolerance" :rules="rules4"
                  :disabled="disableInput">
                </v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('break_in')"
                    v-model="addItem.break_in"
                    type="time"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('break_out')"
                    v-model="addItem.break_out"
                    type="time"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col> -->
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-row justify="center">
            <v-btn color="primary" style="border: solid 1px #3277D5;" text @click="close" class="mr-2">{{$t('cancel')}}
            </v-btn>
            <v-btn color="primary" :loading="loading" @click="editListTime(editItem)">{{$t('save')}}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteScheduleTime" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_this_shift_code')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" style="border: solid 1px #3277D5;" text @click="deleteScheduleTime = false"
            class="mr-2">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteListTime(itemToDelete.id)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table :search="search" :items="time_master" :headers="headers" class="elevation-1 mt-3"
      :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
        {{ items.itemsLength }} </template>
      <template v-slot:item.work_in="{ item }">
        {{ item.work_in | hour }} {{ getTimezone(item) }}
      </template>
      <template v-slot:item.work_out="{ item }">
        {{ item.work_out | hour }} {{ getTimezone(item) }}
      </template>
      <template v-slot:item.tolerance="{ item }">
        <div v-if="item.tolerance && item.tolerance !== 0">{{ item.tolerance }} {{$t('minutes')}}</div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.action="{ item }">
        <span v-if="item.schedule_code != 'x' && item.schedule_code != 'X'">
          <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
          <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
        </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    name: "times",
    data() {
      const lang = localStorage.getItem('lang') || 'id';
      return {
        lang: lang,
        headers: [{
            text: this.$i18n.t('shift_code'),
            value: "schedule_code"
          },
          {
            text: this.$i18n.t('title'),
            value: "description"
          },
          {
            text: this.$i18n.t('work_in'),
            value: "work_in"
          },
          {
            text: this.$i18n.t('work_out'),
            value: "work_out"
          },
          {
            text: this.$i18n.t('tolerance'),
            value: "tolerance"
          },
          // { text: this.$i18n.t('break_out'), value: "break_out" },
          {
            text: this.$i18n.t('manage'),
            value: "action"
          },
        ],
        timezone: [{
            name: "WIB",
            id: 7,
          },
          {
            name: "WITA",
            id: 8,
          },
          {
            name: "WIT",
            id: 9,
          },
        ],
        rules4: [
          v => /^([0-9]|[1-9][0-9])$/.test(v) || this.$i18n.t('number_required'),
          (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
        ],
        company_id: this.$store.state.company,
        validator: this.$store.state.validator,
        baseUrl: this.$store.state.baseUrl,
        time_master: [],
        addScheduleTime: false,
        editScheduleTime: false,
        deleteScheduleTime: false,
        addItem: {
          description: "",
          schedule_code: "",
          work_in: null,
          work_out: null,
          break_in: null,
          break_out: null,
          companyId: "",
          tolerance: 0,
          timezone: null
        },
        editItem: {
          description: "",
          schedule_code: "",
          work_in: null,
          work_out: null,
          break_in: null,
          break_out: null,
          id: "",
          tolerance: 0,
          errorCode: 'Error add shift master',
          timezone: null
        },
        itemToDelete: {
          id: "",
          description: "",
          companyId: "",
        },
        times: [{
          id: "",
          description: "",
          companyId: "",
        }, ],
        get_id: [],
        search: "",
        editedIndex: -1,
        valid: true,
        rules: [(v) => !!v || this.$i18n.t('field_required')],
        rulesMidnight: [
          (v) => !!v || this.$i18n.t('field_required'),
          (v) => (v && v !== '00:00') || 'Please use different time',
        ],
        rulesMaxChar: [
          (v) => !!v || this.$i18n.t('field_required'),
          (v) => (v && v.length < 9) || this.$i18n.t('max_8'),
        ],
        rulesMaxChar50: [
          (v) => !!v || this.$i18n.t('field_required'),
          (v) => (v && v.length < 51) || this.$i18n.t('max_50'),
        ],
        loading: false,
        checkbox: true,
        rulesHoliday: [],
        disableInput: false,
      };
    },
    methods: {
      getTimezone(time) {
        if (time.work_in) {
          switch (parseInt(time.timezone)) {
            case 7:
              return 'WIB'
            case 8:
              return 'WITA'
            case 9:
              return 'WIT'
            default:
              return ''
          }

        } else {
          return '-'
        }
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      changeRules(data) {
        if (data == true) {
          this.checkbox = true
          this.rulesHoliday = [];
          this.rulesMidnight = [];
          this.disableInput = true;
          this.editItem.work_in = null;
          this.editItem.work_out = null;
          this.editItem.break_in = null;
          this.editItem.break_out = null;
          this.editItem.timezone = null;
          this.editItem.tolerance = 0;
          this.addItem.work_in = null;
          this.addItem.work_out = null;
          this.addItem.break_in = null;
          this.addItem.break_out = null;
          this.addItem.timezone = null;
          this.addItem.tolerance = 0;
        } else {
          this.checkbox = false
          this.rulesHoliday = this.rules;
          this.rulesMidnight = this.rules;
          this.disableInput = false;
        }
      },
      addedItem() {
        this.addScheduleTime = true;
      },
      close() {
        this.addScheduleTime = false;
        this.alert = false;
        this.editScheduleTime = false;
        this.deleteScheduleTime = false;
      },
      editedItem(item) {
        if (item.work_in) {
          this.checkbox = false
        } else {
          this.checkbox = true
        }
        this.editedIndex = this.times.indexOf(item);
        this.editItem = Object.assign({}, item);
        this.editScheduleTime = true;
        this.getListTime();
      },
      deleteItem(item) {
        this.itemToDelete = Object.assign({}, item);
        this.deleteScheduleTime = true;
      },
      async getListTime() {
        const result = await this.$store.dispatch('getScheduleShiftMasterByCompany', {
          companyId: this.company_id
        })
        this.times = result;
        this.time_master = result;
      },
      async addListTime(item) {
        this.loading = true;
        const body = {
          description: item.description,
          schedule_code: item.schedule_code,
          work_in: item.work_in,
          work_out: item.work_out,
          break_in: item.break_in,
          break_out: item.break_out,
          tolerance: item.tolerance,
          timezone: item.timezone,
          companyId: this.company_id,
        }
        const result = await this.$store.dispatch('saveScheduleShiftV3', body)
        this.loading = false;
        if (result) {
          this.addScheduleTime = false;
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.getListTime();
        }
      },
      async editListTime(item) {
        this.loading = true;
        const body = {
          description: item.description,
          schedule_code: item.schedule_code,
          work_in: item.work_in,
          work_out: item.work_out,
          break_in: item.break_in,
          break_out: item.break_out,
          tolerance: item.tolerance,
          timezone: item.timezone,
          id: item.id,
        }
        const result = await this.$store.dispatch('editScheduleShiftV3', body)
        this.loading = false;
        if (result) {
          this.editScheduleTime = false;
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.getListTime();
        }
      },
      async deleteListTime(id) {
      const result = await this.$store.dispatch('deleteScheduleShiftV3', {id, language: this.lang.toUpperCase()})
      if (result) {
        this.deleteScheduleTime = false;

        if (result.data.flag) {
          this.showMessage("success", result.message)
        } else {
          this.showMessage("warning", result.message)
        }
        this.getListTime();
      }
    },
    },
    created() {
      this.getListTime();
      this.changeRules(false);
    },
    watch: {
      addScheduleTime() {
        if (this.$refs.addForm) {
          this.$refs.addForm.reset();
        }
      },
    },
  };
</script>
<style scoped>
  .set-radio1::before {
    content: 'Day-Off';
    position: absolute;
    bottom: 75px;
    left: 10px;
    height: 10px;
  }

  .set-radio2::before {
    content: 'Libur';
    position: absolute;
    bottom: 75px;
    left: 10px;
    height: 10px;
  }
</style>